var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.9231C24 17.1077 23.5548 18.1846 22.8194 19H1.48258C0.56129 17.9808 0 16.6308 0 15.1538C0 12.2035 2.23394 9.77231 5.11084 9.43L5.35045 8.71577C4.70864 8.59654 3.99368 8.58423 3.19355 8.72346C3.68903 6.03846 6.05806 4 8.90323 4C10.8867 4 12.6372 4.99115 13.6846 6.50077C14.4449 5.9 15.4053 5.53846 16.4516 5.53846C18.9097 5.53846 20.9032 7.51923 20.9032 9.96154C20.9032 10.0269 20.9032 10.0923 20.8994 10.1577C20.1735 10.1923 19.4961 10.4623 19.0014 10.7223L19.2008 11.3162C19.2523 11.3146 19.3026 11.3077 19.3548 11.3077C21.9213 11.3077 24 13.3731 24 15.9231ZM10.8662 12.4615L11.2258 16.6923H12.7742L13.1338 12.4615H15.4839L12 8.23077L8.51613 12.4615H10.8662Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.a3def344934ce9c14d7a2374e9e871ef.svg";
export { ForwardRef as ReactComponent };